import { useMemo } from 'react';
import { useAppScopeStore } from '@frontend/scope';
import { hasInsuranceVerificationAccessForLocation } from '../utils/utils';

export const useGetHasInsuranceVerificationAccess = (locationId: string) => {
  const { selectedLocationIds } = useAppScopeStore();

  const isMultiLocation = selectedLocationIds.length > 1;

  const { allChildLocationIdDoNotHaveAccess, locationIdsWithAccess } = useMemo(() => {
    if (!isMultiLocation) {
      return { allChildLocationIdDoNotHaveAccess: false, locationIdsWithAccess: [] };
    }
    const locationIdsWithAccess = selectedLocationIds.filter((locationId) => {
      return hasInsuranceVerificationAccessForLocation(locationId);
    });
    const allChildLocationIdDoNotHaveAccess = locationIdsWithAccess.length === 0;

    return { allChildLocationIdDoNotHaveAccess, locationIdsWithAccess };
  }, [isMultiLocation, selectedLocationIds]);

  const hasWeaveInsuranceVerificationFullAccess = hasInsuranceVerificationAccessForLocation(locationId);

  return {
    hasWeaveInsuranceVerificationFullAccess,
    isMultiLocation,
    allChildLocationIdDoNotHaveAccess,
    locationIdsWithAccess,
  };
};
